<template>
  <div class="row">
    <div class="col-lg-12 profile-details">
      <h2 class="cp-title">Change Password</h2>

      <form @submit="changePassword">
        <div class="form-group">
          <label>Old Password<span class="required">*</span></label>
          <input
            type="password"
            ref="name"
            v-model="formData.old_password"
            class="form-control"
          />
        </div>

        <div class="form-group">
          <label>New Password<span class="required">*</span></label>
          <input
            type="password"
            ref="new_password"
            v-model="formData.new_password"
            class="form-control"
          />
        </div>

        <div class="form-group">
          <label>Confirm Password<span class="required">*</span></label>
          <input
            type="password"
            ref="confirm_password"
            v-model="formData.confirm_password"
            class="form-control"
          />
        </div>

        <div class="form-group">
          <button type="submit" class="btn btn-primary">
            Update Password
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errors: [],
      formData: {
        old_password: "",
        new_password: ""
      }
    };
  },
  methods: {
    changePassword: function(e) {
      e.preventDefault();
      if (!this.formData.old_password) {
        this.$refs.name.focus();
        this.flashMessage.error({ message: "Old password required" });
        return false;
      }
      if (!this.formData.new_password) {
        this.$refs.new_password.focus();
        this.flashMessage.error({ message: "New password required" });
        return false;
      }
      if (!this.formData.confirm_password) {
        this.$refs.confirm_password.focus();
        this.flashMessage.error({ message: "Confirm password required" });
        return false;
      }
      if (this.formData.new_password !== this.formData.confirm_password) {
        this.$refs.confirm_password.focus();
        this.flashMessage.error({ message: "Passwords do not match." });
        return false;
      }

      this.$authHttp
        .post("customer-password-change", this.formData)
        .then(response => {
          if (response.data.status) {
            this.flashMessage.success({
              message: response.data.message
            });
            this.$helper.logout();
          } else {
            this.flashMessage.success({
              message: response.data.message
            });
          }
        })
        .catch(e => {
          this.flashMessage.error({
            message: error.response.data.message
          });
        });
    }
  }
};
</script>
